import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const tabs = [
  { id: "preventivi", label: "Preventivi" },
  { id: "storico", label: "Storico" },
  { id: "report", label: "Report" },
];

function DealerHeader({
  activeTab,
  onTabChange,
  onOpenAdminRates,
  onOpenAdminConditions,
  showTabs = true,
  actionLabel = "Gestione Accordo",
  onActionClick,
  secondaryActionLabel,
  onSecondaryActionClick,
}) {
  const theme = useTheme();
  const handleActionClick = onActionClick || onOpenAdminRates;
  const handleSecondaryActionClick = onSecondaryActionClick || onOpenAdminConditions;

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Typography variant="h3" display="inline">
        Dealer
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
        {showTabs && (
          <Stack direction="row" spacing={4}>
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <Typography
                  key={tab.id}
                  onClick={() => onTabChange && onTabChange(tab.id)}
                  sx={{
                    cursor: "pointer",
                    fontWeight: 700,
                    color: isActive ? "primary.main" : theme.palette.text.secondary,
                    borderBottom: isActive ? `2px solid ${theme.palette.primary.main}` : "2px solid transparent",
                    pb: 0.5,
                    transition: "all 0.15s ease",
                  }}
                >
                  {tab.label}
                </Typography>
              );
            })}
          </Stack>
        )}

        <Button
          variant="outlined"
          onClick={handleActionClick}
          sx={{ textTransform: "none", fontWeight: 700 }}
        >
          {actionLabel}
        </Button>

        {secondaryActionLabel && handleSecondaryActionClick && (
          <Button
            variant="outlined"
            onClick={handleSecondaryActionClick}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            {secondaryActionLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default DealerHeader;
